import React from 'react';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography
} from '@mui/material';
import { BRAND, primaryButtonSx } from '../../styles/ui';

interface SafetyGuidanceDialogProps {
  open: boolean;
  onClose: () => void;
  confirmed: boolean;
  onConfirmedChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // Signed-in users confirmed this at registration: show it ticked and locked
  readOnly?: boolean;
}

const SafetyGuidanceDialog: React.FC<SafetyGuidanceDialogProps> = ({
  open,
  onClose,
  confirmed,
  onConfirmedChange,
  readOnly = false
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    aria-labelledby="safety-guidance-title"
    aria-describedby="safety-guidance-description"
  >
    <DialogTitle id="safety-guidance-title">Safety Guidance</DialogTitle>
    <DialogContent>
      <Typography id="safety-guidance-description" sx={{ mb: 3 }}>
        It's essential to ensure that your email address is secure. If you have any concerns about your current email's security, consider creating a new account protected with multi-factor authentication. Alternatively, you may wish to use a trusted family member's or friend's email address instead.
      </Typography>
      <FormControlLabel
        disabled={readOnly}
        control={
          <Checkbox
            checked={readOnly || confirmed}
            onChange={onConfirmedChange}
            sx={{ '&.Mui-checked': { color: readOnly ? BRAND.accent : BRAND.pink } }}
          />
        }
        label="I have read and understood the safety guidance"
        sx={{ '& .MuiFormControlLabel-label.Mui-disabled': { color: BRAND.muted } }}
      />
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3 }}>
      <Button onClick={onClose} variant="contained" sx={primaryButtonSx}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default SafetyGuidanceDialog;
